import React from 'react';

const Refund = () => {
  return (
    <div className="bg-[#02042b] text-white px-6 py-16">
      {/* Header Section */}
      <div
        className="w-full h-64 bg-cover bg-center"
        style={{ backgroundImage: "url('img/bg-img/breadcumb.jpg')" }}
      >
        <div className="flex items-center justify-center h-full bg-[#2223354d] bg-opacity-50">
          <h1 className="text-3xl md:text-5xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 via-yellow-300 to-yellow-200 uppercase">
            Refund And Cancellation Policy
          </h1>
        </div>
      </div>

      {/* Content Section */}
      <div className="max-w-6xl mx-auto space-y-12 mt-12">
        <section>
          <h2 className="text-3xl font-bold mb-4">Privacy Policy</h2>
          <p className="text-gray-300 mb-4">
            This Privacy Policy describes Our policies and procedures on the collection, use and disclosure of Your information when You use the Service and tells You about Your privacy rights and how the law protects You.
          </p>
          <p className="text-gray-300 mb-4">
            We use Your Personal data to provide and improve the Service. By using the Service, You agree to the collection and use of information in accordance with this Privacy Policy. This Privacy Policy has been created with the help of the Privacy Policy Generator.
          </p>
        </section>

        <section>
          <h3 className="text-2xl font-semibold mb-4 text-blue-300">Interpretation and Definitions</h3>
          <h4 className="text-xl font-semibold mb-2">Interpretation</h4>
          <p className="text-gray-300 mb-4">
            The words of which the initial letter is capitalized have meanings defined under the following conditions. The following definitions shall have the same meaning regardless of whether they appear in singular or in plural.
          </p>
          <h4 className="text-xl font-semibold mb-2">Definitions</h4>
          <ul className="list-disc list-inside text-gray-300 space-y-2">
            <li><strong>Account:</strong> A unique account created for You to access our Service or parts of our Service.</li>
            <li><strong>Affiliate:</strong> An entity that controls, is controlled by, or is under common control with a party.</li>
            <li><strong>Company:</strong> Infinite Solution, Kolkata Batanagar.</li>
            <li><strong>Cookies:</strong> Small files stored on Your device.</li>
            <li><strong>Country:</strong> West Bengal, India</li>
            <li><strong>Device:</strong> Any device that can access the Service.</li>
            <li><strong>Personal Data:</strong> Information related to an identifiable individual.</li>
            <li><strong>Service:</strong> Refers to the Website.</li>
            <li><strong>Service Provider:</strong> Third-party companies or individuals who process data on behalf of the Company.</li>
            <li><strong>Usage Data:</strong> Data collected automatically such as IP address, browser type, time spent on pages.</li>
            <li><strong>Website:</strong> Infinite Solution, accessible from https://infinitesolutionedu.com/index.html</li>
            <li><strong>You:</strong> The individual accessing or using the Service.</li>
          </ul>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-blue-300 mb-4">Collecting and Using Your Personal Data</h2>
          <h3 className="text-xl font-bold mb-2">Types of Data Collected</h3>
          <h4 className="text-lg font-semibold mb-1">Personal Data</h4>
          <ul className="list-disc list-inside text-gray-300 mb-4">
            <li>Email address</li>
            <li>First name and last name</li>
            <li>Phone number</li>
            <li>Usage Data</li>
          </ul>
          <h4 className="text-lg font-semibold mb-1">Usage Data</h4>
          <p className="text-gray-300 mb-4">Collected automatically including IP address, browser, device data, and usage patterns.</p>
          <h3 className="text-xl font-bold mb-2">Tracking Technologies and Cookies</h3>
          <ul className="list-disc list-inside text-gray-300 mb-4">
            <li><strong>Cookies:</strong> Used for authentication and improving user experience.</li>
            <li><strong>Web Beacons:</strong> Monitor user interactions.</li>
            <li><strong>Essential Cookies:</strong> Required for basic site functionality.</li>
            <li><strong>Acceptance Cookies:</strong> Remember cookie policy consent.</li>
            <li><strong>Functionality Cookies:</strong> Save preferences like login and language.</li>
          </ul>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-blue-300 mb-4">Use of Your Personal Data</h2>
          <ul className="list-disc list-inside text-gray-300 space-y-2">
            <li>To provide and improve our services.</li>
            <li>To manage Your account and deliver services.</li>
            <li>To contact You for support or promotional communication.</li>
            <li>To fulfill legal obligations and manage requests.</li>
          </ul>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-blue-300 mb-4">Data Retention & Transfers</h2>
          <p className="text-gray-300">Your data is retained as long as needed for business or legal reasons. Transfers comply with data security laws.</p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-blue-300 mb-4">Your Rights</h2>
          <p className="text-gray-300">You may request access, correction, or deletion of your data. Some data may be required for legal or operational reasons.</p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-blue-300 mb-4">Data Disclosure</h2>
          <ul className="list-disc list-inside text-gray-300 space-y-2">
            <li>To legal authorities if required.</li>
            <li>In business transactions such as mergers.</li>
            <li>To protect company rights or user safety.</li>
          </ul>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-blue-300 mb-4">Security and Children's Privacy</h2>
          <p className="text-gray-300">We do not knowingly collect data from children under 13. Data is secured, but no system is 100% secure.</p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-blue-300 mb-4">External Links & Policy Updates</h2>
          <p className="text-gray-300">Our site may link to third parties. Updates to this policy will be posted on this page.</p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-blue-300 mb-4">Contact Us</h2>
          <p className="text-gray-300">If you have questions, contact us at:</p>
          <p className="text-gray-300">Phone: +91 83360 68682</p>
          <p className="text-gray-300 italic text-sm mt-2">Generated using Privacy Policies Generator</p>
        </section>
      </div>
    </div>
  );
};

export default Refund;